module.exports = "/assets/data/a173edd2830fb473ac33eaf768842548-L32.data.json";